import { AuthService } from "./../../services/auth.service";
import { MyListService } from "./../../services/my-list.service";
import {
  FormsModule,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { AppComponent } from "../../app.component";
import * as $ from "jquery";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
  selector: "app-create-foko",
  templateUrl: "./create-foko.component.html",
  styleUrls: ["./create-foko.component.css"]
})
export class CreateFokoComponent implements OnInit {

  mainInputValue: String;
  secondInputValue: String;

  foko = {
    mainArray: [],
    secondArray: [],
    listname: "",
    mainLanguage: "",
    secondLanguage: "",
    code: Number
  };

  fokoSettingsForm = new FormGroup({
    listname: new FormControl("", [Validators.required]),
    mainLanguage: new FormControl("", [Validators.required]),
    secondLanguage: new FormControl("", [Validators.required]),
    difficulty: new FormControl("Normal", [Validators.required]),
    code: new FormControl("public", [Validators.required])
  });

  newGlossaryForm = new FormGroup({
    mainLanguageWord: new FormControl(),
    secondLanguageWord: new FormControl()
  });

  // tslint:disable-next-line:max-line-length
  languages = ["Norwegian", "English", "Afrikaans", "Albanian", "Amharic", "Arabic", "Armenian", "Azerbaijani", "Basque", "Belarusian", "Bengali", "Bosnian", "Bulgarian", "Catalan", "Cebuano", "Chichewa", "Chinese", "Corsican", "Croatian", "Czech", "Danish", "Dutch", "English", "Esperanto", "Estonian", "Filipino", "Finnish", "French", "Frisian", "Galician", "Georgian", "German", "Greek", "Gujarati", "Haitian", "Hausa", "Hawaiian", "Hebrew", "Hindi", "Hmong", "Hungarian", "Icelandic", "Igbo", "Indonesian", "Irish", "Italian", "Japanese", "Javanese", "Kannada", "Kazakh", "Khmer", "Korean", "Kurdish", "Kyrgyz", "Lao", "Latin", "Latvian", "Lithuanian", "Luxembourgish", "Macedonian", "Malagasy", "Malay", "Malayalam", "Maltese", "Maori", "Marathi", "Mongolian", "Myanmar", "Nepali", "Norwegian", "Pashto", "Persian", "Polish", "Portuguese", "Punjabi", "Romanian", "Russian", "Samoan", "Scots", "Serbian", "Sesotho", "Shona", "Sindhi", "Sinhala", "Slovak", "Slovenian", "Somali", "Spanish", "Sundanese", "Swahili", "Swedish", "Tajik", "Tamil", "Telugu", "Thai", "Turkish", "Ukrainian", "Urdu", "Uzbek", "Vietnamese", "Welsh", "Xhosa", "Yiddish", "Yoruba", "Zulu"];

  constructor(
    public router: Router,
    public myListService: MyListService,
    // public capitalizePipe: CapitalizePipe,
    public appComponent: AppComponent,
    public database: AngularFireDatabase,
    public auth: AuthService
  ) { }

  ngOnInit() {
    $("#titleInput").keyup(function (event) {
      // TODO
      console.log("hello");
      const textBox = event.target;
      const start = textBox.selectionStart;
      const end = textBox.selectionEnd;
      textBox.value =
        textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1);
      textBox.setSelectionRange(start, end);
    });
  }

  submitFirstPage() {

    if (this.fokoSettingsForm.value.mainLanguage === this.fokoSettingsForm.value.secondLanguage) {
      console.log('not ok');
      // TODO create dialog
    } else {
    console.log('Adding form values to foko');
    console.log('Form values', this.fokoSettingsForm.value);
    this.foko = Object.assign(this.foko, this.fokoSettingsForm.value); // merging form with foko object
    console.log(this.foko);
    }
  }

  addGlossary() {
    this.foko.mainArray.push(this.mainInputValue);
    this.foko.secondArray.push(this.secondInputValue);

    // resetting input values.
    const myInput = <HTMLInputElement>document.getElementById("myInput");
    myInput.focus();
    this.mainInputValue = "";
    this.secondInputValue = "";
    console.log(this.foko);
  }

  removeGlossary(glossaryMain: string) {
    const index = this.foko.mainArray.indexOf(glossaryMain);
    this.foko.mainArray.splice(index, 1);
    this.foko.secondArray.splice(index, 1);
  }

  /* pipe(event) {
    event.target.value = this.capitalizePipe.transform(event.target.value);
  } */

  save() {
    console.log('Foko', this.foko);
    // private list
    const that = this;
    if (!that.foko.code) {
      delete this.foko.code;
    }
    this.myListService.databaseLocation.push(that.foko)
      .then(function () {
        if (that.foko.code) {
          // public list
          that.database
            .object("codes/" + that.generateCode())
            .set(that.foko)
            .then(() => {
              that.navigateHome();
            });
        } else {
          that.navigateHome();
        }
      });
  }

  generateCode(): Number { // Create a new foko code => check the database if it exists. If not => return it
    let code = Math.floor(Math.random() * 1000000) + 1000;
    if (this.database
      .object("codes/" + code)
      .snapshotChanges()
      .take(1)
      .subscribe(data => {
        if (!data)
          return true;
      })) {
      return code;
    }
  }

  navigateHome() {
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/create-foko/create-foko.component.ts